import { Injectable } from '@angular/core';
import { URLSearchParams, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ApiService } from '../shared/services/api.service';
import { RequestOptions, Request, RequestMethod } from '@angular/http';

@Injectable()
export class HomeService {

    baseURL = "/api/mvp"
    constructor(
        private apiService: ApiService
    ) { }


    searchLead(data) {
        return this.apiService.post(this.baseURL + '/lead/searchLeadbyKeyword', data)
            .map(
            (response: Response) => {
                return response;
            }
            )
            .catch(
            (error: Response) => {
                return Observable.throw('Something went wrong');
            }
            );
    }

}


// WEBPACK FOOTER //
// ./src/app/home/home.service.ts